import { ReactNode, useEffect, useState } from 'react';
import './SidebarButton.css';
import { Icon } from '../Icon';
import { useNavigate } from 'react-router-dom';

type Subitem = {
  label: string;
  url?: string;
  onClick?: () => void;
  show?: boolean;
};

type Props = {
  active?: boolean;
  className?: string;
  onClick?: () => void;
  icon?: ReactNode;
  label?: string;
  subitems?: Subitem[];
  arrow?: boolean;
  collapsed?: boolean;
  url?: string;
  onButtonClick?: () => void;
};

export default function SidebarButton(props: Props) {
  const navigate = useNavigate();
  const [showSubitems, setShowSubitems] = useState(false);
  const sidebarButtonClasses = ['sidebutton'];
  const maxHeight = props.collapsed ? '0px' : showSubitems ? '1000px' : '0px';
  if (props.className) sidebarButtonClasses.push(props.className);
  if (props.active) sidebarButtonClasses.push('side-button--active');

  useEffect(() => {
    if (props.collapsed) {
      setShowSubitems(false);
    }
  }, [props.collapsed]);

  const handleItemClick = () => {
    if (props.url) {
      navigate(props.url);
    } else {
      if (props.collapsed) {
        props.onButtonClick && props.onButtonClick();
        setShowSubitems(!showSubitems);
      } else {
        setShowSubitems(!showSubitems);
      }
    }
  };

  if (props.subitems?.every((it) => it.show === false)) return <></>;

  return (
    <div className="sidebar__button-wrapper">
      <button
        className={sidebarButtonClasses.join(' ')}
        onClick={handleItemClick}
      >
        <div className="sidebutton__icon sidebutton__icon--xs">
          {props.icon}
        </div>
        <div className="sidebutton__label sidebutton__label--xs font-s-14px font-weight-medium">
          {props.label}
        </div>
        <div className="arrow-icon">
          {props.arrow ? (
            showSubitems ? (
              <Icon>expand_more</Icon>
            ) : (
              <Icon>expand_less</Icon>
            )
          ) : null}
        </div>
      </button>
      <div className="sidebar__subitems-wrapper" style={{ maxHeight }}>
        {props.subitems && (
          <div className="sidebar__subitems">
            {props.subitems.map((subitem, index) =>
              subitem.show === false ? (
                <></>
              ) : (
                <button
                  key={index}
                  className="sidebar__subitem sidebutton sidebutton__label sidebutton__label--xs font-s-14px font-weight-medium button-itens"
                  onClick={() => {
                    subitem.url && navigate(subitem.url);
                  }}
                >
                  {subitem.label}
                </button>
              )
            )}
          </div>
        )}
      </div>
    </div>
  );
}
